<template>
  <v-content class="campaign page"></v-content>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  created() {
    const signup = this.$route.query['s']

    this.$store.dispatch('campaign/fetch', this.$route.params.slug).then(() => {
      if (this.campaign.opportunity) {
        return this.$router.push(
          `/opportunities/${this.campaign.opportunity.id}${signup ? `?s=${signup}` : ''}`
        )
      }
      if (this.campaign.organization) {
        return this.$router.push(
          `/organizations/${this.campaign.organization.id}${signup ? `?s=${signup}` : ''}`
        )
      }
    }).catch(() => this.$router.push('/candidate/signup'))
  },

  computed: mapGetters({
    campaign: 'campaign/model',
    role: 'auth/role',
  }),
}
</script>
